import errors from 'errors'
import { serialize } from 'helpers'
import { getAccessTokenData } from 'helpers/web_to_client'
import { formatMessage } from 'locale'

const MAX_AUTH_FAILS = 3

function getCookie(cookie_name) {
    const name = `${cookie_name}=`
    const cookies = document.cookie.split(';')

    for (let cookie of cookies) {
        cookie = cookie.trim()
        if (cookie.startsWith(name)) {
            return cookie.substring(name.length)
        }
    }
    return undefined
}

export async function authenticate(forceFetchAccessToken = false) {
    let token = await getAccessTokenData(forceFetchAccessToken)
    return await Promise.all([
        authenticateTokenWithRetries(token, verifyToken),
        authenticateTokenWithRetries(token, verifyTokenWGCG),
    ])
}

async function authenticateTokenWithRetries(token, verifyFunction, forceNewToken = false, authFails = 1) {
    try {
        if (forceNewToken) {
            token = await getAccessTokenData(true)
        }
        return await verifyFunction(token)
    } catch (error) {
        if (authFails > MAX_AUTH_FAILS) throw error
        return authenticateTokenWithRetries(token, verifyFunction, true, authFails + 1)
    }
}

async function verifyToken({ access_token, periphery_id, spa_id }) {
    const queryParams = { access_token, periphery_id, spa_id }

    const wgshApiUrl = window.config ? window.config.WGSH_API_URL : ''
    const authUrl = '/oauth/verify/token' + serialize(queryParams)
    const url = `${wgshApiUrl}${authUrl}`
    const requestParams = {
        method: 'GET',
        credentials: 'include',
    }
    const resp = await fetch(url, requestParams)

    if (!resp.ok) {
        throw await resp.text()
    }
}

async function verifyTokenWGCG({ access_token }) {
    const wgcgApiUrl = window.config ? window.config.WGCG_API_URL : ''
    const authUrl = '/login/access_token/'  // WGCG URL must end with a slash
    const url = `${wgcgApiUrl}${authUrl}`
    const requestParams = {
        headers: {
            'X-Access-Token': access_token,
        },
        credentials: 'include',
    }

    const resp = await fetch(url, requestParams)

    if (!resp.ok) {
        throw await resp.text()
    }
}

export function httpRequest(url, method = 'GET', data = {}, language) {
    const contentType = 'application/json'
    const headers = {
        Accept: contentType,
        'Content-Type': contentType,
    }
    if (language) {
        headers['Accept-Language'] = language
    }
    const csrfTokenCookie = getCookie('wgsh_csrf_token')
    if (csrfTokenCookie) {
        headers['X-CSRF-Token'] = csrfTokenCookie
    }

    const requestParams = {
        method,
        credentials: 'include',
        headers,
    }
    if (method !== 'GET') {
        requestParams.body = JSON.stringify(data)
    }
    const wgshApiUrl = window.config ? window.config.WGSH_API_URL : ''
    const absoluteUrl = url.startsWith('/game_api') ? `${wgshApiUrl}${url}` : url

    return fetcher(absoluteUrl, requestParams)
}

async function fetcher(url, requestParams) {
    try {
        const response = await fetch(url, requestParams)
        return processFetchResponse(response, url, requestParams)
    } catch (error) {
        throw {
            errorMessage: formatMessage(errors.unknownError),
            statusCode: error.response ? error.response.status : 500,
        }
    }
}

async function processFetchResponse(resp, url, requestParams) {
    if (resp.ok) {
        const data = await resp.text()
        // some methods return empty string, which fail JSON.parse
        return data && JSON.parse(data)
    }

    if (resp.status === 401) {
        // authorize and retry
        try {
            await authenticate()
            return fetcher(url, requestParams)
        } catch (errorText) {
            throw {
                errorMessage: JSON.parse(errorText).title,
                statusCode: resp.status,
            }
        }
    }

    let errorMessage
    if (resp.status === 503) {
        errorMessage = ''

    } else if (resp.status >= 400 && resp.status <= 500) {
        const data = await resp.text()
        errorMessage = JSON.parse(data).title

    } else {
        errorMessage = formatMessage(errors.unknownError)

    }

    throw {
        errorMessage,
        statusCode: resp.status,
    }
}



// WEBPACK FOOTER //
// ./http.js